import {
    SET_CTA_ACTION,
    SET_CTA_ACTION_SUCCESS,
    SET_CTA_ACTION_FAILURE,
    RESET_CTA_ACTION,
} from '../actions/index';

const initialState = {
    ctaClicked:'',
    orderStatus:'',
};

const ctaDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_CTA_ACTION:
            return { ...state, 
                ctaClicked: action.payload.ctaClicked,
                orderStatus: action.payload.orderStatus,};
        case RESET_CTA_ACTION:
            return {
                ...state,
                loading: false,
                ctaClicked:'',
                orderStatus:'',
            };
        default:
            return {
                ...state,
            };
    }
};

export default ctaDataReducer;
